module.exports = __webpack_public_path__ + "img/avator.3bcdb690.png";